/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react'
import { Menu, Container, Image, Grid, Icon } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

const propTypes = {
  subpages: PropTypes.object.isRequired,
  siteLabel: PropTypes.string.isRequired,
  siteLogoUrl: PropTypes.string.isRequired,
  toggleVisibility: PropTypes.func.isRequired
}
class MainNav extends Component {
  renderMenuItems = subpages => {
    const menuItems = Object.keys(subpages).map(page => {
      return (
        <Menu.Item
          link
          key={subpages[page].label}
          name={subpages[page].path}
          id="menu-link"
          as={NavLink}
          exact
          to={subpages[page].path}
        />
      )
    })
    return menuItems
  }

  renderDesktopMenu = (url, label, subpages) => {
    const menuItems = this.renderMenuItems(subpages)
    return (
      <Menu fixed="top" color={'black'} inverted>
        <Container>
          <Menu.Item as="a" header id="menu-link">
            <a href="https://www.facebook.com/Slikopleskarstvo-in-suhomonta%C5%BEa-Cvetek-475761759163471/?fref=ts">
              <Icon size="large" name="facebook" />{label}</a>
          </Menu.Item>
          <Menu.Menu position="right">{menuItems}</Menu.Menu>
        </Container>
      </Menu>
    )
  }

  renderMobileMenu = (url, label, toggleVisibility) => {
    return (
      <Menu stackable fixed="top" color={'black'} inverted >
          <Menu.Menu position="left">
            <Menu.Item
              position="right"
              link
              key={'mobile-menu'}
              icon="content"
              onClick={toggleVisibility}
            />
          </Menu.Menu>
      </Menu>
    )
  }

  render() {
    const { subpages, siteLabel, siteLogoUrl, toggleVisibility } = this.props
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column only="tablet computer">
            {this.renderDesktopMenu(siteLogoUrl, siteLabel, subpages)}
          </Grid.Column>
          <Grid.Column only="mobile">
            {this.renderMobileMenu(siteLogoUrl, siteLabel, toggleVisibility)}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

MainNav.propTypes = propTypes
export default MainNav



// WEBPACK FOOTER //
// ./src/components/MainNav.js